import React, { Component } from 'react'

import View from 'react-flexbox'
import { Typography } from '@material-ui/core'
import { TabelaScorpion } from 'scorpion-core'

import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import TablePagination from '@material-ui/core/TablePagination';

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

class Tabela extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 15,
            ordem: 'asc',
            colunaOrdem: -1,
        };
    }

    updateOrdem(coluna, ordem) {
        this.setState({
            colunaOrdem: coluna,
            ordem
        }, this.ordenar);
    }

    getRenderItemHeader(coluna, index) {

        const { ordem, colunaOrdem } = this.state;
        let novaOrdem = ordem == 'asc' ? 'desc' : 'asc';
        return <View key={"Header" + index} style={{
            color: "#929292",
            padding: 5,
            height: 35,
            maxHeight: 35,
            alignItems: 'center'


        }}
            onClick={() => this.updateOrdem(index, novaOrdem)}
        >
            {coluna.label}
            {colunaOrdem == index &&
                <span>
                    {ordem == 'asc' ?
                        <ArrowUpward style={{ fontSize: 16, marginBottom: -2, marginLeft: 4 }} />
                        :
                        <ArrowDownward style={{ fontSize: 16, marginBottom: -2, marginLeft: 4 }} />
                    }
                </span>
            }
        </View>
    }
    getRenderItemCell(coluna, linha, indexL) {
        let value = coluna.getValue(linha, indexL);
        let comp = value;

        if (typeof value === 'string' || typeof value === 'number') {
            comp = <Typography style={{ overflow: 'auto', height: 50 }} {...coluna.props}> {value}</Typography>
        }


        return <View key={"cell" + coluna.label + indexL} style={{
            borderBottom: 1,
            borderBottomColor: '#e0e0e0',
            borderBottomStyle: 'solid',
            padding: 5,
            alignItems: 'center',
            height: 60,
            maxHeight: 60,

        }}>{comp}</View>
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    getSorting(order, orderBy) {
        return order === 'desc' ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
    }
    desc(a, b, orderBy) {

        if (orderBy === -1) {
            return 0;
        }

        const { colunas } = this.props;
        let bValue = colunas[orderBy].getValue(b);
        let aValue = colunas[orderBy].getValue(a);

        if (typeof bValue === 'string') {
            bValue = bValue.toLowerCase();
        }

        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
        }
        if (!bValue && aValue) {
            return -1;
        }
        if (bValue && !aValue) {
            return 1;
        }

        if (!isNaN(bValue) && !isNaN(aValue)) {
            return parseFloat(bValue) - parseFloat(aValue)
        }

        if (bValue < aValue) {
            return -1;
        }
        if (bValue > aValue) {
            return 1;
        }


        return 0;
    }
    render() {
        let { rowsPerPage, page, ordem, colunaOrdem } = this.state;
        const { colunas, data, mensagemVazio, loading, paginacao, fullScreen } = this.props;
        let mobile = fullScreen;


        let linhas = data ? data.slice() : [];

        linhas = stableSort(linhas, this.getSorting(ordem, colunaOrdem));

        if (paginacao) {
            linhas = linhas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        }






        if (mobile) {
            return <Tabela colunas={colunas} data={linhas} mensagemVazio={mensagemVazio} loading={loading} paginacao={paginacao} />
        } else {
            return (
                <View column style={{ height: 1 }}>
                    {/* <div style={{ display: 'flex', backgroundColor: "#f00" }}>


                        {colunas.map((coluna, index) => {
                            return <View column key={index} style={{ flex: 1, padding: 1, width: 1, backgroundColor: "#00f" }}>
                                {this.getRenderItemHeader(coluna)}
                            </View>
                        })}
                    </div> */}

                    <View style={{ overflow: 'auto', flex: 1 }}>


                        {colunas.map((coluna, index) => {
                            let flex = 1;
                            if (coluna.label === "Titulo" || coluna.label === "titulo") {
                                flex = 3
                            }
                            return <View column key={index} style={{ flex: flex, padding: 1, justifyContent: 'flex-start' }}>
                                {this.getRenderItemHeader(coluna, index)}
                                {linhas.map((linha, indexL) => { return this.getRenderItemCell(coluna, linha, indexL) })}
                            </View>
                        })}
                    </View>
                    <View style={{ flexGrow: 0, flexShrink: 1, justifyContent: "flex-end" }}>
                        {linhas.length && paginacao ?
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 250, 500]}
                                component="div"
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                            :
                            ""
                        }
                    </View>
                </View>
            )
        }
    }
}


Tabela = withMobileDialog({ breakpoint: 'xs' })(Tabela);



export default Tabela;


// WEBPACK FOOTER //
// ./src/components/ConsultaCrud/componente/Tabela/index.js